<template>
  <div class="ips-navbar" @mouseleave="closeNav" @click="openNav" :class="activeNav ? 'active' : ''">
    <div class="ips-navbar-items">
      <div class="ips-navbar-items__item ips-navbar-items__item--logo" @click="toggleInfo">
        <div class="ips-navbar-items__item-parent">
          <div class="ips-navbar-items__item-icon">
            <img src="@/assets/logo/logo.svg" />
          </div>
          <div class="ips-navbar-items__item-content">
            <span>Keep it smart</span>
          </div>
        </div>
      </div>
      <div
        class="ips-navbar-items__item"
        :class="
          `${isExpanded(item) ? 'ips-navbar-items__item--active' : ''} ${
            isCurrent(item) || hasActiveChild(item) ? 'ips-navbar-items__item--current' : ''
          }`
        "
        @click="handleClick(item, $event)"
        v-for="item in filteredMenu"
        :key="`menu-item-${item.id}`"
      >
        <div class="ips-navbar-items__item-parent">
          <div class="ips-navbar-items__item-icon">
            <i :class="`fas fa-${item.nav.icon}`"></i>
            <span>{{ $t(item.nav.name) }}</span>
          </div>
          <div class="ips-navbar-items__item-content">
            {{ $t(item.nav.name) }}
          </div>
        </div>
        <div
          class="ips-navbar-items__item-children"
          :class="`${isExpanded(item) ? 'ips-navbar-items__item-children--active' : ''}`"
          :style="getChildrenStyles(item)"
        >
          <div
            class="ips-navbar-items__item-child"
            :class="`${isCurrent(child) ? 'ips-navbar-items__item-child--current' : ''}`"
            v-for="child in item.children"
            :key="`menu-child-${child.id}`"
          >
            <router-link :to="{ path: child.path }">{{item.languageSupport ? $t(child.nav.name) :  child.nav.name}}</router-link>
          </div>
        </div>
      </div>
    </div>
    <GlobModal :show="showInfo" :width="10" @close="showInfo = false">
      <div class="ips-info" style="text-align: center;">
        <img style="width: 70%;" class="kits-logo" src="@/assets/logo/logo-black.svg" />
        <div class="ips-info__content">
          <p>Support: <a href="mailto:helpdesk@invens.se">helpdesk@invens.se</a></p>
          <p>Inquires: <a href="mailto:hello@invens.se">hello@invens.se</a></p>
        </div>
        <p style="font-size: .7rem;">Keep It Smart &copy; Invens AB 2020</p>
      </div>
    </GlobModal>
  </div>
</template>

<script>
import menuItems from "./menuItems";
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { routes, createNav } from "@/router";
export default {
  setup() {
    const router = useRouter();
    const expanded = ref([]);
    const handleClick = (item, e) => {
      if (item.children && item.children.length > 0) {
        if (isExpanded(item)) {
          expanded.value.splice(expanded.value.indexOf(item.id), 1);
        } else {
          expanded.value = [];
          expanded.value.push(item.id);
        }
      } else {
				e.stopPropagation();
        router.push(item.path);
      }
    };
    const isExpanded = (item) => {
      return expanded.value.includes(item.id);
    };
    const getChildrenStyles = (item) => {
      return isExpanded(item) ? `max-height: ${item.children.length * 40}px` : "";
		};
		
		const activeNav = ref(false);
    const closeNav = () => {
      	expanded.value = [];
		activeNav.value = false;
    };
    const openNav = () => {
      activeNav.value = true;
    };

    const path = computed(() => router.currentRoute.value.path);
    const isCurrent = (item) => {
      return item.path && item.path == path.value;
    };
    const hasActiveChild = (item) => {
      return router.currentRoute.value.matched.map((i) => i.path).includes(item.path);
    };

    const showInfo = ref(false);
    const toggleInfo = () => {
      showInfo.value = !showInfo.value;
    };

    const filteredMenu = createNav(routes);
    return {
      filteredMenu,
      handleClick,
      isExpanded,
      getChildrenStyles,
      expanded,
      closeNav,
      isCurrent,
      hasActiveChild,
      showInfo,
      toggleInfo,
			openNav,
			activeNav
    };
  }
};
</script>

<style lang="scss" scoped>
.ips-info {
  &__content {
    margin: 1rem 0;
    p {
      margin: 0.5rem 0;
    }
  }
}
.ips-navbar {
  //New version
  height: 100vh;
  width: 120px;
  min-width: 120px;
  left: 0px;
  top: 0px;
  border-radius: 0px;
  background: linear-gradient(180deg, #64A216 0%, #0E7617 100%);
  z-index: 10;

  //Old version
  overflow: hidden;
  overflow-y: auto;
  position: sticky;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  @include scrollbar(4px);
  &.active {
    min-width: 140px;
  }
  &.active &-items__item {
    &-icon {
      span {
        // opacity: 0;
      }
      i {
        // transform: translateY(0.6rem);
      }
    }
  }
  &.active &-items__item-content {
    opacity: 1;
  }
}
.ips-navbar-items {   
  
  &__item {
	margin-bottom: 2rem;
    &-parent {
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      display: flex;
      align-items: center;
      &:hover {
        background-color: darken($kits-green, 10%);
      }
    }
    &-content {
      transition: opacity 0.2s ease-in;
      color: white;
      font-size: 0.7rem;
      max-width: 0;
      opacity: 0;
      text-transform: uppercase;
    }
    &-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 95px;
      padding: 1rem 0;
      i {
        transition: all 0.3s ease-in-out;
        font-size: 1.3rem;
        color: white;
      }
      span {
        transition: all 0.3s ease-in-out;
        font-size: 12px;
        display: block;
        text-transform: uppercase;
        color: white;
        margin-top: 5px;
      }
      img {
        height: 25px;
        width: auto;
        transition: all 0.3s ease-in-out;
        filter: grayscale(100%) brightness(2);
        &:hover {
          filter: grayscale(0%) brightness(1);
        }
      }
    }
    &-children {
      max-height: 0;
      overflow: hidden;
      transition: all 0.2s ease-in-out;
    }
    &-child {
		transition: all 0.2s ease-in-out;
		position: relative;
		display: flex;
		justify-content: center;
		text-transform: uppercase;
		font-size: 12px;
		display: contents;
      a {
        height: 40px;
        display: flex;
        align-items: center;
        color: white;
        font-weight: 400;
        text-decoration: none;
		justify-content: center;
      }
      &:hover {
        background-color: darken($kits-green, 10%);
      }
      &--current {
        border-right: 4px solid $kits-green;
        background-color: darken($kits-green, 10%);
      }
    }
    &--current &-parent {
      border-left: 4px solid $kits-green;
      background-color: darken($kits-green, 10%);
      i,
      span {
        margin-left: -4px;
      }
    }
    &--active &-parent {
      @include box-shadow(4);
    }
    &--active &-children {
      background-color: darken($kits-green, 3%);
    }
    &--logo {
      height: 40px;
      border-bottom: 2px solid darken($kits-green, 10%);
      img {
        height: 25px;
        width: auto;
        transition: all 0.3s ease-in-out;
        filter: grayscale(100%) brightness(2);
      }
      &:hover img {
        filter: grayscale(0%) brightness(1);
      }
    }
    &--logo &-icon {
      padding: 0.5rem 0;
    }
  }
}


//New design
.ips-navbar-items__item{
	margin-top: 1rem;
}
.ips-navbar-items__item--logo{
  height: unset;
  border-bottom: none;
}
.ips-navbar-items__item-icon{
   margin: auto;
   img{
      height: 57.34323501586914px;
      width: 30px;
   }
}

.ips-navbar-items__item--current{
  .ips-navbar-items__item-parent{
    border-left:unset;
    background-color: unset;
  }

.ips-navbar-items__item-icon{

    // width: 72.999962px;
		background: linear-gradient(59.05deg, #438411 3.94%, #438411 63.41%);
		border-radius: 15px;
	}
}

.ips-navbar-items__item-parent:hover{
	background-color: unset;
	.ips-navbar-items__item-icon{
		// width: 72.999962px;
		background: linear-gradient(59.05deg, #438411 3.94%, #438411 63.41%);
		border-radius: 15px;;
	}
}
</style>
